import { TestPlanService } from '@/api/testPlan';
import { HideCustomCreateButton } from '@/components/shared/button/HideCustomButtonCreate';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { IFilterSpec } from '@/components/shared/filter/TableFilterPanel';
import { ExtendedTableLowCode } from '@/components/shared/table/ExtendedTableLowCode';
import { useBackNavigate } from '@/utils/hooks/useBackNavigate';
import { useCustomSpec } from '@/utils/hooks/useCustomSpec';
import { Button, Dialog, ModalRef } from 'alurkerja-ui';
import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

export const ListArchiveTestPlan: React.FC = () => {
  const { id } = useParams();
  const backNavigate = useBackNavigate();
  const ref = useRef<ModalRef>(null);

  const spec = useCustomSpec('/api/crud/test-plan', {
    columns: [
      { key: 'plan_name', label: 'Title' },
      { key: 'description', label: 'Description' },
    ],
  });

  const filterSpec: IFilterSpec[] = [
    { name: 'plan_name', label: 'Title', type: 'text' },
    { name: 'description', label: 'Description', type: 'text' },
  ];

  const [selectedRow, setSelectedRow] = useState<string[]>([]);
  const { mutate: unArchiveMutate, isPending: isUnarchiveLoading } =
    TestPlanService.useUnarchive();

  const unarchiveAction = (idList: string[]) => {
    idList.forEach(id => {
      unArchiveMutate(id, {
        onSuccess: () => {
          Dialog.success({
            title: 'Success',
            description: 'Plan has been Unarchived',
            callback: () => {
              ref.current?.closeModal();
              backNavigate();
            },
          });
        },
        onError: () => {
          Dialog.error({
            title: 'Error',
            description: 'Failed to Unarchive plan',
          });
        },
      });
    });
  };

  return (
    <div className="tab-group">
      <div className="justify-between tab-list">
        <OutlineButton onClick={backNavigate}>Back</OutlineButton>

        <Button
          onClick={() => unarchiveAction(selectedRow)}
          loading={isUnarchiveLoading}
          disabled={selectedRow.length === 0}
        >
          Revert Back
        </Button>
      </div>

      <div className="mx-4">
        <ExtendedTableLowCode
          spec={spec}
          defaultFilter={{ project_id: id, is_archive: true }}
          hideActionColumn
          customButtonCreate={HideCustomCreateButton}
          showFilter
          filterSpec={filterSpec}
          showCheckbox
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      </div>
    </div>
  );
};
